import React, { useState, useEffect } from 'react';
import './RandomImages.css'; // Ensure this path is correct

const images = [
  { src: '/images/scrap1.png', alt: "Hello", aspectRatio: 5 / 8 },
  { src: '/images/scrap2.png', aspectRatio: 12 / 8 },
  { src: '/images/scrap3.png', aspectRatio: 11.5 / 8},
  { src: '/images/scrap4.jpg', aspectRatio: 8 / 10.5},
  { src: '/images/scrap5.png', aspectRatio: 8 / 8},  
  { src: '/images/scrap6.png', aspectRatio: 8 / 8},  
  { src: '/images/scrap7.png', aspectRatio: 8 / 8},  
  { src: '/images/scrap8.png', aspectRatio: 8 / 8},  
  { src: '/images/scrap9.png', aspectRatio: 8 / 8},  
  { src: '/images/scrap10.png', aspectRatio: 8 / 25},  
  { src: '/images/scrap11.png', aspectRatio: 11.5 / 8},  
  { src: '/images/scrap12.png', aspectRatio: 8 / 11},  
  { src: '/images/scrap13.png', aspectRatio: 8 / 11.5},  
  { src: '/images/scrap14.png', aspectRatio: 11.5 / 8},  
  { src: '/images/scrap15.png', aspectRatio: 8 / 11.5},  
  { src: '/images/scrap16.png', aspectRatio: 8 / 11},  
  { src: '/images/scrap17.png', aspectRatio: 8 / 11},  
  { src: '/images/scrap18.png', aspectRatio: 11.5 / 8},  
  { src: '/images/scrap19.png', aspectRatio: 8 / 12.5},  
  { src: '/images/scrap20.png', aspectRatio: 8 / 11},  
  { src: '/images/scrap21.png', aspectRatio: 8 / 11.5},  
  { src: '/images/scrap22.png', aspectRatio: 12 / 8},  
  { src: '/images/scrap23.png', aspectRatio: 8 / 13},  
  { src: '/images/scrap24.png', aspectRatio: 12.5 / 8},  
  { src: '/images/scrap25.png', aspectRatio: 8 / 12.5}
];

const doRectanglesOverlap = (r1, r2) => {
  return !(r2.left >= r1.right || 
           r2.right <= r1.left || 
           r2.top >= r1.bottom || 
           r2.bottom <= r1.top);
};

const getRandomStyle = (aspectRatio, existingStyles) => {
  let isOverlapping = true;
  let style = {};

  while (isOverlapping) {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const x = Math.floor(Math.random() * (viewportWidth - 50)); // Ensure the image fits within viewport width
    const y = Math.floor(Math.random() * (viewportHeight - 50)); // Ensure the image fits within viewport height
    const width = Math.floor(Math.random() * (viewportWidth / 2)) + 50; // Random width between 50px and half viewport width
    const height = width / aspectRatio; // Calculate height based on aspect ratio

    // Ensure height fits within viewport height
    if (y + height > viewportHeight) {
      continue;
    }

    style = {
      top: `${y}px`,
      left: `${x}px`,
      width: `${width}px`,
      height: `${height}px`,
    };

    const newRect = {
      left: x,
      top: y,
      right: x + width,
      bottom: y + height
    };

    isOverlapping = existingStyles.some(existingStyle => {
      const existingRect = {
        left: parseFloat(existingStyle.left),
        top: parseFloat(existingStyle.top),
        right: parseFloat(existingStyle.left) + parseFloat(existingStyle.width),
        bottom: parseFloat(existingStyle.top) + parseFloat(existingStyle.height)
      };
      return doRectanglesOverlap(existingRect, newRect);
    });
  }

  return style;
};

const RandomImages = () => {
  const [styles, setStyles] = useState([]);

  useEffect(() => {
    const newStyles = images.map(image => getRandomStyle(image.aspectRatio, styles));
    setStyles(newStyles);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="image-container">
      {images.map((image, index) => (
        <img
          key={index}
          src={image.src}
          alt={`Random ${index}`}
          style={styles[index]}
          className="random-image"
        />
      ))}
    </div>
  );
};

export default RandomImages;